import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const TransportLazy = React.lazy(
	() => import(/* webpackChunkName : 'Transport' */ './components/Transport')
);

export default (store) => {
	return [
		{
			path: 'home/transport',
			element: <AsyncLoading component={<TransportLazy />} />,
		},
	];
};
